const translationEs = {
    comu: {
        si: "Si",
        no: "No",
        resetFiltre: "Borrar filtro",
        detall: "Ver el detalle",
        tancar: "Cerrar",
        deselecionar: "Deseleccionar todo",
        noRegistres: 'No hay registros',
        refrescar: 'Refrescar',
    },
    page: {
        notFound: "No encontrado",
    },
    clients: {
        title: "Clientes",
        create: "Crear cliente",
        update: "Modificar cliente",
    },
    zones: {
        title: "Zonas",
        create: "Crear zona",
        update: "Modificar zona",
    },
    zonesUser: {
        title: "Zonas de usuario",
        create: "Crear zona de usuario",
        update: "Modificar zona de usuario",
    },
    reserves: {
        title: "Reservas",
        titleDetall: "Reserva",
        create: "Crear reserva",
        update: "Modificar reserva",
        readOnly: "Detalle de reserva",
        totals: {
            title: "Totales",
            adults: "Adultos",
            infants: "Niños",
            bebes: "Bebes",
            efectiu: "Efectivo",
            targeta: "Tarjeta",
            reserves: "Reservas",
            total: "Total",
        },
        exportarA3: "Descargar export A3",
        reservaManual: "Esta reserva ha sido modificada manualmente",
        liniaManual: "Alguna de las líneas de esta reserva han sido modificadas manualmente",
        reservaLiniaManual: "Tanto esta reserva como alguna de sus líneas han sido modificadas manualmente",
        altres: 'Otros',
        campsEveret: 'Campos Everet',
        seleccionarTot: 'Seleccionar todas las reservas',
        noTraspassats: {
            aplicat: "Se ha aplicado el filtro de los no traspasados",
            noAplicat: "Número de reservas no traspasadas a Everet. Haga clic para consultarlas",
        },
    },
    recursos: {
        title: "Recursos",
        create: "Crear recurso",
        update: "Modificar recurso",
    },
    embarcacions: {
        title: "Embarcaciones",
        create: "Crear embarcación",
        update: "Modificar embarcación",
    },
    reservesDescompte: {
        title: "Descuentos de reserva",
        create: "Crear descuentos de reserva",
        update: "Modificar descuentos de reserva",
    },
    reservesLinia: {
        title: "Linias de reserva",
        create: "Crear linias de reserva",
        update: "Modificar linias de reserva",
    },
    requisitsRecurs: {
        title: "Requisitos de recursos",
        create: "Crear requisitos de recursos",
        update: "Modificar requisitos de recursos",
    },
    requerimentsRecurs: {
        title: "Requerimientos de recursos",
        create: "Crear requerimiento de recursos",
        update: "Modificar requerimiento de recursos",
    },
    users: {
        title: "Usuarios",
        create: "Crear usuario",
        update: "Modificar usuario",
        password: {
            title: "Cambiar contraseña",
            caption: "Rellenar sólo si se quiere modificar la contraseña del usuario",
        },
    },
    productes: {
        title: "Productos",
        create: "Crear producto",
        update: "Modificar producto",
    },
    agendesProducte: {
        title: "Disponibilidad del producto",
        create: "Crear disponibilidad del producto",
        update: "Modificar disponibilidad del producto",
        readOnly: "Detalle de disponibilidad del producto",
        tab: {
            taula: 'Lista',
            calendari: 'Calendario',
        },
        actions: {
            planificar: {
                title: 'Planificar',
                tabForm: 'Datos generales',
            },
            seleccionar: 'Seleccionar todas las disponibilidades',
        },
        detall: {
            title: 'Ver detalle',
        },
        calendari: {
            switchProductes: "Filtrar por todos los productos",
        },
    },
    parametres: {
        title: 'Parámetros',
        titleMobil: 'Precio Cuevas para la aplicación móvil',
        titleComptabilitat: 'Parámetros para contabilidad',
        titleCreuers: 'Paràmetres de Creuers',
        titleVerifactu: 'Parámetros para Verifactu',
        titleRegimsIva: 'Parámetros para Régimenes IVA'
    },
    informes: {
        title: 'Informes por zona y vendedor',
        create: 'Crear informe',
        update: 'Modificar informe',
        totals: {
            efectiu: 'Efectivo',
            targeta: 'Tarjeta',
            tiquets: 'Tiques',
            coves: 'Cuevas',
            total: 'Importe total',
            resultats: 'Resultados',
        },
    },
    informesTripulacio: {
        title: 'Informe de tripulación por recurso y/o embarcación',
        patrons: 'Patrones',
        mecanics: 'Mecánicos',
        tripulancio: 'Tripulación',
        marinerFotos: 'Marinero fotos',
        marinerBar: 'Marinero bar',
        tots: 'Todos los roles',
        columnes: {
            nom: 'Nombre',
            dies: 'Días',
            percentatge: 'Porcentaje',
        },
    },
    informesEmbarcacio: {
        title: 'Informe de tripulación por embarcación',
        patrons: 'Patrones',
        mecanics: 'Mecánicos',
        tripulancio: 'Tripulación',
        columnes: {
            codi: 'Codigo',
            nom: 'Nombre',
            dies: 'Días',
            percentatge: 'Porcentaje',
        },
    },
    grafics: {
        title: 'Uso de recursos',
        ocupacio: 'Ocupación por recurso y hora',
        alert: 'No hay una fecha seleccionada, por favor selecciona una fecha.',
        refrescar: 'Refrescar',
    },
    proveidor: {
        title: 'Proveedor',
        create: 'Crear proveedor',
        update: 'Modificar proveedor',
    },
    centreCost: {
        title: 'Centro de costes',
        create: 'Crear centro de coste',
        update: 'Modificar centro de coste',
    },
    rutes: {
        title: 'Rutas planificadas',
        create: 'Crear ruta planificada',
        update: 'Modificar ruta planificada',
        rutesMassives: 'Creación de rutas a partir de disponibilidades',
        resultatsRutes: 'Resultados de la creación de rutas a partir de disponibilidades',
        tabs: {
            punt: {
                title:'Puntos de la ruta',
                create: 'Crear punto',
                update: 'Modificar punto',
                observacions: 'Observaciones',
            },
            usuari: {
                title: 'Tripulación',
                create: 'Crear tripulante',
                update: 'Modificar tripulante',
            },
            incidencia: {
                title: 'Incidencias',
                create: 'Crear incidencia',
                update: 'Modificar incidencia',
            },
        },
    },
    series: {
        title: 'Series',
        create: 'Crear una serie',
        update: 'Modificar la serie',
    },
    terminals: {
        title: 'Terminales',
        create: 'Crear un terminal',
        update: 'Modificar un terminal',
    },
    tripulants: {
        title: 'Tripulantes',
        create: 'Crear un tripulante',
        update: 'Modificar un tripulante',
    },
    tripulantRuta: {
        title: 'Ruta-Tripulante',
        create: 'Crear Ruta-Tripulante',
        update: 'Modificar Ruta-Tripulante',
    },
    articles: {
        title: 'Artículos',
        create: 'Crear artículo',
        update: 'Modificar artículo',
    },
    registresVerifactu: {
        title: 'Control de errores Verifactu',
        create: '',
        update: 'Detalle del registro'
    },
    categories: {
        title: 'Categorías',
        create: 'Crear categoría',
        update: 'Modificar categoría',
    },
    articleExistencies: {
        title: 'Existencias',
        create: 'Crear existencia',
        update: 'Modificar existencia',
        action: {
            operacioCompra: {
                quantitat: 'Cantidad',
                quantitatPlaceHolder: 'Cantidad de artículos comprados',
            },
            operacioInventari: {
                quantitat: 'Cantidad',
                quantitatPlaceHolder: 'Cantidad de artículos',
            },
            operacioTraspas: {
                quantitat: 'Cantidad',
                quantitatPlaceHolder: 'Cantidad de artículos a traspasar',
            },
        },
    },
    everet: {
        title: 'Everet',
        versio: 'Versión',
        estat: 'Estado',
        anarEveret: 'Ir a Everet',
        actiu: 'Activo',
        inactiu: 'Inactivo',
    },
    versio: {
        title: 'Versión',
        subTitle: 'Información de la versión',
        nom: 'Nombre del proyecto',
        versio: 'Versión',
        data: 'Fecha',
        declaracioResponsable: 'Declaración responsable',
    },
    operacio: {
        title: 'Operaciones',
        titleDetall: 'Operación',
        create: 'Crear operación',
        update: 'Modificar operación',
        readOnly: 'Detalle de operación',
        operacioManual: "Esta operación ha sido modificada manualmente",
        liniaManual: "Alguna de las líneas de esta operación han sido modificadas manualmente",
        operacioLiniaManual: "Tanto esta operación como alguna de sus líneas han sido modificadas manualmente",
        noTraspassats: {
            aplicat: "Se ha aplicado el filtro de los no traspasados",
            noAplicat: "Numero de reservas no traspasadas a Everet. Haga clic para consultarlas",
        },
        totals: {
            title: "Totales",
            efectiu: "Efectivo",
            targeta: "Tarjeta",
            operacions: "Operaciones",
            total: "Total",
        },
        linies: {
            title: 'Líneas de operación',
            create: 'Crear línea de operación',
            update: 'Modificar línea de operación',
            view: 'Línea de operación',
            totals: {
				preuMig : 'Precio medio',
				totalQuantitat: 'Cantidad total'
			},
            liniesArticle: {
                title: 'Líneas de artículo',
                create: 'Crear líneas de artículo',
                update: 'Modificar líneas de artículo',
            },
        },
        action: {
            campAbonament: 'Cantidad a reembolsar',
            campPreuAbonament: 'Precio por cantidad a reembolsar',
            tooltipCampAbonament: 'Índica la cantidad de artículos que quieres reembolsar',
            tooltipCampPreuAbonament: 'Índica el precio individual de cada cantidad que quieres reembolsar',
            seleccionarTot: 'Seleccionar todas las operaciones',
        },
    },
    opcions: {
        title: 'Opciones',
        create: 'Crear una opción',
        update: 'Modificar una opción',
    },
    articlesOpcions: {
        title: 'Artículos / opciones',
        create: 'Crear artículo / opción',
        update: 'Modificar artículo / opción',
        opcioSeleccionada: 'Artículos seleccionables para la opción',
        tooltipTancarOpcio: 'Cerrar opción seleccionada',
    },
    consumTripulacio: {
        title: 'Consumo de tripulación',
        create: 'Crear consumo de tripulación',
        update: 'Modificar consumo de tripulación',
        readOnly: 'Detalle de consumo de tripulación',
        totals: {
            title: "Totales",
            efectiu: "Efectivo",
            targeta: "Tarjeta",
            operacions: "Operaciones",
            total: "Total",
        },
    },
    talonaris: {
        title: 'Talonarios',
        create: 'Crear talonario',
        update: 'Modificar talonario',
    },
    bonosTalonari: {
        title: 'Bonos de talonarios',
        create: 'Crear bono de talonario',
        update: 'Modificar bono de talonario',
        tooltipModificarEstat: 'Filtrar por tipo afiliado y selecciona registros para poder ejecutar la acción de modificar estado',
        anarTalonari: 'Ver talonario',
    },
    controlFotografia: {
        title: 'Control de fotografía',
        create: 'Crear control de fotografía',
        update: 'Modificar control de fotografía',
        totals: {
            postalsFetes: 'Postales hechas',
            postalsVenudes: 'Postales vendidas',
            importPostals: 'Importe postales',
            clauersFets: 'Llaveros hechos',
            clauersVenuts: 'Llaveros vendidos',
            importClauers: 'Importe llaveros',
            totalVenut: 'Total vendido',
            totalControlsFotografia: 'Total control de fotografía',
            importTargeta: 'Importe tarjeta',
            importEfectiu: 'Importe efectivo',
            importTotal: 'Importe total',
        },
    },
    registreVerifactu: {
        title: 'Detalles del registro',
        correccioErrorsRemissioTitle: 'Corrección de errores en la remisión a Verifactu',
        factura: 'Ir a la factura',
        numSerieFactura: 'Número factura',
        fechaExpedicionFactura :'Fecha de expedición',
        importeTotal :'Importe total',
        enviamentDataEnviament :'Fecha de envio',
        respostaEstadoRegistro :'Estado del registro',
        respostaDescripcionError :'Descripción del error',
        operacion :'Operación',
        idVersion :'Id versión',
        idEmisorFactura :'Emisor factura',
        sifNumeroInstalacion :'Número de instalación',
        secuencia :'Secuencia',
        tipoFactura :'Tipo de factura',
        cuotaTotal :'Cuota total',
        primerRegistro :'Primer registro',
        tipoHuella :'Tipo de huella',
        sifNif :'NIF del expedidor',
        sifNombre :'Nombre Sif',
        sifId :'Sif id',
        sifVersion :'Vesion sif',
        sifTipoUsoPosibleSoloVerifactu :'Tipo de uso posible sólo Verifactu',
        sifTipoUsoPosibleMultiOt :'Tipo de uso posible multi OT',
        sifIndicadorMultiplesOT :'Indicador sif multiples OT',
        recuperat :'Recuperado',
        sifEmpresa :'Sif empresa',
        maxNumSerieId :'Máximo número serie',
        createdBy :'Usuario de creación',
        createdDate :'Fecha de creación',
        httpRequestAvailable :'Http request available',
        tipus :'Tipo',
        registroAnteriorFechaExpedicionFactura :'Fecha de expedión del registro anterior',
        nombreRazonEmisor :'Razón emisor',
        descripcionOperacion :'Descripción de la operación',
        huella :'Huella',
        sifNombreRazon :'Nombre razón sif',
        urlVerificacion :'URL de verificación',
        description :'Descripción',
        botoEncongir :'Esconder campos',
    	botoDesplegar :'Mostrar más campos',
        desglose: {
			title: 'Desglose',
        	impuesto: 'Impuesto',
        	claveRegimen: 'Clave del régimen',
        	calificacionOperacion: 'Calificación de la operación',
        	tipoImpositivo: 'Tipo impositivo',
        	baseImponibleOimporteNoSujeto: 'Base imponible o importe no sujeto',
        	cuotaRepercutida: 'Cuota repercutida',
        	impostos: {
	            IMP_01: "IVA",
	            IMP_02: "IPSI",
	            IMP_03: "IGIC",
	            IMP_05: "Altres"
	        },
	        clausRegim: {
			    CLR_01: "Operación de régimen general",
			    CLR_02: "Exportación",
			    CLR_03: "Operaciones a las que se aplique el régimen especial de bienes usados, objetos de arte, antigüedades y objetos de colección",
			    CLR_04: "Régimen especial del oro de inversión",
			    CLR_05: "Régimen especial de las agencias de viajes",
			    CLR_06: "Régimen especial grupo de entidades en IVA (Nivel Avanzado)",
			    CLR_07: "Régimen especial del criterio de caja",
			    CLR_08: "Operaciones sujetas al IPSI / IGIC (Impuesto sobre la Producción, los Servicios y la Importación / Impuesto General Indirecto Canario)",
			    CLR_09: "Facturación de las prestaciones de servicios de agencias de viaje que actúan como mediadoras en nombre y por cuenta ajena (D.A.4ª RD1619/2012)",
			    CLR_10: "Cobros por cuenta de terceros de honorarios profesionales o de derechos derivados de la propiedad industrial, de autor u otros por cuenta de sus socios, asociados o colegiados efectuados por sociedades, asociaciones, colegios profesionales u otras entidades que realicen estas funciones de cobro",
			    CLR_11: "Operaciones de arrendamiento de local de negocio",
			    CLR_14: "Factura con IVA pendiente de devengo en certificaciones de obra cuyo destinatario sea una Administración Pública",
			    CLR_15: "Factura con IVA pendiente de devengo en operaciones de tracto sucesivo",
			    CLR_17: "Operación acogida a alguno de los regímenes previstos en el Capítulo XI del Título IX (OSS e IOSS)",
			    CLR_18: "Recargo de equivalencia",
			    CLR_19: "Operaciones de actividades incluidas en el Régimen Especial de Agricultura, Ganadería y Pesca (REAGYP)",
			    CLR_20: "Régimen simplificado"
			}
    	},        	
    },
};

export default translationEs;
